import { Link } from '../buttons';
import styled from 'styled-components';

export const SectionLink = styled(Link)`
    font-weight: 500;
    font-size: 13px;
`;
